import { useMemo, useState } from "react";
import { applyLogView, LogView, LogViewOptions } from "./logGrouping";
import type { ReflectorLogRecord } from "./logRecord";

/**
 * The state behind the logs toolbar and the Exclude filter, plus the view it
 * produces over the loaded lines. Shared by the V1 and V2 pages so the three
 * switches and the exclusions behave the same in both; all three switches start
 * on.
 */
export function useLogsView<TRaw>(
  records: ReflectorLogRecord<TRaw>[],
  matchesSearch?: LogViewOptions<TRaw>["matchesSearch"]
) {
  const [excludes, setExcludes] = useState<string[]>([]);
  const [hideHeartbeats, setHideHeartbeats] = useState(true);
  const [groupRepeated, setGroupRepeated] = useState(true);
  const [wrapMessages, setWrapMessages] = useState(true);

  const view: LogView<TRaw> = useMemo(
    () => applyLogView(records, { matchesSearch, excludes, hideHeartbeats, groupRepeated }),
    [records, matchesSearch, excludes, hideHeartbeats, groupRepeated]
  );

  return {
    view,
    excludes,
    setExcludes,
    hideHeartbeats,
    setHideHeartbeats,
    groupRepeated,
    setGroupRepeated,
    wrapMessages,
    setWrapMessages,
  };
}
